import { requestApi, parseResponse } from '~/services/api.js';
import { getLocalBTag, getReferrerUrl } from '~/store/cookies.js';

const host = '/';

async function cancelBankIDRequest(orderRef) {
	const response = await requestApi(`${host}bankid/cancel`, { orderRef }, 'POST');
	return response;
}

async function requestBankIDToken(payload = {}) {
	const response = await requestApi(`${host}bankid/autoStartToken/`, payload, 'POST');
	return response;
}

async function verifyUser(orderRef) {
	const response = await requestApi(`${host}bankid/verifyUser`, { orderRef }, 'POST');
	return response;
}

async function bankIdResult({ orderRef, siteId, franchiseID, defaultLocale, selectedLocale, requestType, googleID }) {
	const btag = getLocalBTag();
	const referrerUrl = getReferrerUrl();
	const payload = {
		orderRef,
		siteID: parseInt(siteId, 10),
		franchiseID: parseInt(franchiseID, 10),
		locale: defaultLocale,
		selectedLocale,
		clientId: googleID,
		isNewRegistrationFlow: !requestType, // if there is no request type, its the play now flow
		...(requestType ? { requestType } : {}),
		...(btag ? { btag } : {}),
		...(referrerUrl ? { referrerUrl } : {})
	};
	const timestamp = Date.now();
	const response = await requestApi(`${host}bankid/initiateSession?timestamp=${timestamp}`, payload, 'POST');
	return response;
}

async function bankIdReinitiate({
	orderRef,
	siteId,
	franchiseID,
	defaultLocale,
	selectedLocale,
	requestType,
	googleID
}) {
	const btag = getLocalBTag();
	const referrerUrl = getReferrerUrl();
	const payload = {
		orderRef,
		siteID: parseInt(siteId, 10),
		franchiseID: parseInt(franchiseID, 10),
		locale: defaultLocale,
		selectedLocale,
		clientId: googleID,
		isNewRegistrationFlow: !requestType, // if there is no request type, its the play now flow
		...(requestType ? { requestType } : {}),
		...(btag ? { btag } : {}),
		...(referrerUrl ? { referrerUrl } : {})
	};
	const timestamp = Date.now();
	const response = await requestApi(`${host}bankid/re-initiateSession?timestamp=${timestamp}`, payload, 'POST');
	return response;
}

async function bankIdSetLimits(depositLimits, orderRef) {
	const response = await requestApi(
		`${host}bankid/setLimits`,
		{
			dayAmount: depositLimits[0].amount,
			dayFreq: depositLimits[0].freq.toUpperCase(),
			weekAmount: depositLimits[1].amount,
			weekFreq: depositLimits[1].freq.toUpperCase(),
			monthAmount: depositLimits[2].amount,
			monthFreq: depositLimits[2].freq.toUpperCase(),
			orderRef
		},
		'POST'
	);
	return response;
}

async function bankIdSessionLookup(orderRef) {
	const response = await requestApi(`${host}bankid/lookupSession`, orderRef, 'POST');
	return response;
}

async function bankIdAcceptTerms(orderRef) {
	const response = await requestApi(`${host}bankid/acceptTerms`, orderRef, 'POST');
	return response;
}

async function bankIdAcceptPrivacyPolicy(orderRef) {
	const response = await requestApi(`${host}bankid/acceptPrivacyPolicy`, orderRef, 'POST');
	return response;
}
async function bankIdExtraInfo(payload) {
	const { email } = payload;
	const endpoint = email ? 'setEmail' : 'setMobileNumber';

	const response = await requestApi(`${host}bankid/${endpoint}`, payload, 'POST');
	return response;
}

async function bankIdAccountLink(orderRef) {
	const response = parseResponse(await requestApi(`${host}bankid/setPersonalNo`, { orderRef }, 'POST'));
	return response;
}

export {
	cancelBankIDRequest,
	requestBankIDToken,
	bankIdResult,
	bankIdReinitiate,
	bankIdExtraInfo,
	bankIdAccountLink,
	bankIdSessionLookup,
	bankIdAcceptTerms,
	bankIdAcceptPrivacyPolicy,
	verifyUser,
	bankIdSetLimits
};
